export default __webpack_public_path__ + "static/media/nicoll.7aea8dff.jpg";